import { useEffect } from 'react'
import { isEmpty } from 'ramda'
import CountUp from 'react-countup'

import ENV_VARS from '@/config'
import useCurrentSession from '@/hooks/use-current-session'
import { useHasListings } from '@/hooks/use-has-listings'

import {
  SponsoredListingFaq,
  SponsoredListingHero,
  SponsoredListingHowItWorks,
  SponsoredListingPricing,
  SponsoredListingReview,
  SponsoredListingStats,
  SponsoredListingWhy
} from '../../../devlink'

const { BASE_URL, DASHBOARD_URL } = ENV_VARS
const SponsoredListings = () => {
  const session = useCurrentSession()
  const { hasListings } = useHasListings()
  const hasSession = Boolean(!isEmpty(session) && session?.id)
  const isTenant = session?.user_type === 'tenant'
  const hasListingMessage = hasListings?.message
  useEffect(() => {
    const heroButton = document.getElementById('sl-maincta-getstarted') || {}

    if (hasSession) {
      if (isTenant) {
        heroButton.href = `${DASHBOARD_URL}/rentals?rw=1`
      } else {
        if (hasListingMessage) {
          // Has at least 1 listing ( Draft, Managed, Published, Pending, Hidden, etc... )
          heroButton.href = `${DASHBOARD_URL}/listings`
        } else {
          // Has NO listings
          heroButton.href = `${DASHBOARD_URL}/listing/create/`
        }
      }
    } else {
      heroButton.href = `${BASE_URL}/boost-a-listing?accountType=essentials`
    }
  }, [hasSession, isTenant, hasListingMessage])

  return (
    <div className="webflow-page">
      <SponsoredListingHero />
      <SponsoredListingWhy />
      <SponsoredListingStats
        viewCountText={
          <CountUp start={0} end={300} delay={0.1} suffix="%" enableScrollSpy />
        }
        inquiresCountText={
          <CountUp start={0} end={60} delay={0.1} suffix="%" enableScrollSpy />
        }
        leadsCountText={
          <CountUp start={0} end={70} delay={0.1} suffix="%" enableScrollSpy />
        }
      />
      <SponsoredListingHowItWorks />
      <SponsoredListingReview />
      <SponsoredListingPricing />
      <SponsoredListingFaq />
    </div>
  )
}

export default SponsoredListings
